import React, { FC } from 'react'
import styled from 'styled-components'
import { Button } from 'src/modules/components/lib/button'
import { Clock } from 'src/modules/components/lib/curon-icon'
import { InlineText, Text } from 'src/modules/components/lib/text'
import { View } from 'src/modules/components/lib/view'
import {
  Address,
  AdditionalInfoBox,
  AdditionalInfoRow,
  Card,
  IconBox,
  InfoBox,
  NameLink,
  PharmacyDescriptionBox,
  PharmacyDescriptionTitle,
  PharmacyDescriptionText,
  SummaryBox,
  IrregularOpen,
  RegularOpen,
} from 'src/modules/components/net-application/pharmacy-card'
import { BusinessHourInfo } from 'src/modules/entities/business-hour-info/entity'
import { PharmacySchedule } from 'src/modules/entities/enums/pharmacy-schedule'
import { PharmacyOpenedStatus } from 'src/modules/entities/enums/pharmacy-status'
import {
  PharmacyForFreeDelivery,
  toAddress,
} from 'src/modules/entities/pharmacy/entity'

type Props = {
  nearestFreeDeliveryPharmacy: PharmacyForFreeDelivery | null
  pharmacies: PharmacyForFreeDelivery[] | []
  onSelect: (pharmacy: PharmacyForFreeDelivery) => void
}
export const PharmacyList: FC<Props> = ({
  nearestFreeDeliveryPharmacy,
  pharmacies,
  onSelect,
}) => {
  return (
    <View width="100%">
      {nearestFreeDeliveryPharmacy && (
        <View mx={-4} px={4} py={1} bg={'#FEECCD'}>
          <PharmacyCard
            key={nearestFreeDeliveryPharmacy.uid}
            pharmacy={nearestFreeDeliveryPharmacy}
            onSelect={() => onSelect(nearestFreeDeliveryPharmacy)}
          />
        </View>
      )}
      {pharmacies.length > 0 &&
        pharmacies.map(pharmacy => (
          <PharmacyCard
            key={pharmacy.uid}
            pharmacy={pharmacy}
            onSelect={() => onSelect(pharmacy)}
          />
        ))}
    </View>
  )
}

const PharmacyCard: FC<{
  pharmacy: PharmacyForFreeDelivery
  onSelect: () => void
}> = ({ pharmacy, onSelect }) => {
  const address = toAddress(pharmacy)

  return (
    <Card>
      <SummaryBox>
        <InfoBox>
          {pharmacy.freeDeliveryAvailable && (
            <View mb={3}>
              <FreeDeliveryTag>お薬送料無料</FreeDeliveryTag>
            </View>
          )}
          <NameLink>{pharmacy.name}</NameLink>
          <Address>{address}</Address>
        </InfoBox>
      </SummaryBox>
      <AdditionalInfoBox>
        <AdditionalInfoRow>
          <IconBox>
            <Clock />
          </IconBox>
          <TodayBusinessHour businessHourInfo={pharmacy.businessHourInfo} />
        </AdditionalInfoRow>
      </AdditionalInfoBox>
      {pharmacy.businessHourInfo && pharmacy.businessHourInfo.comment && (
        <PharmacyDescriptionBox>
          <PharmacyDescriptionTitle>薬局紹介</PharmacyDescriptionTitle>
          <PharmacyDescriptionText>
            {pharmacy.businessHourInfo.comment}
          </PharmacyDescriptionText>
        </PharmacyDescriptionBox>
      )}
      <View mt={4}>
        <Button
          colorStyle={'primary-outlined'}
          shape={'square'}
          onClick={onSelect}
        >
          この薬局を選ぶ
        </Button>
      </View>
    </Card>
  )
}

const TodayBusinessHour: FC<{ businessHourInfo: BusinessHourInfo | null }> = ({
  businessHourInfo,
}) => {
  return !businessHourInfo?.targetDateOpeningHour ? (
    <Text>店舗にお問い合わせください</Text>
  ) : (
    <>
      <Text flexShrink={'0'} fontWeight={'bold'}>
        本日
      </Text>
      {businessHourInfo.targetDateOpeningHour.scheduleType ===
        PharmacySchedule.Irregular && (
        <>
          {businessHourInfo.targetDateOpeningHour.status ===
          PharmacyOpenedStatus.Opened ? (
            <IrregularOpen businessHourInfo={businessHourInfo} />
          ) : (
            <InlineText color={'red'}>特別休業</InlineText>
          )}
        </>
      )}

      {businessHourInfo.targetDateOpeningHour.scheduleType ===
        PharmacySchedule.Regular && (
        <>
          {businessHourInfo.targetDateOpeningHour.status ===
          PharmacyOpenedStatus.Opened ? (
            <RegularOpen businessHourInfo={businessHourInfo} />
          ) : (
            <InlineText>休業</InlineText>
          )}
        </>
      )}
    </>
  )
}

const FreeDeliveryTag = styled.div`
  border-radius: 4px;
  padding: 4px 10px;
  font-weight: 600;
  font-size: 14px;
  color: white;
  display: inline-block;
  background-color: #e98e16;
`
